import React from "react";
import { useTranslation } from "react-i18next";

import { Banner } from "fe-shared/src/components";

import { formatWeight } from "../../helpers/invoice";

import { TransactionMaterial } from "../../types";

interface Props {
  materials?: TransactionMaterial[];
  className?: string;
  isInvoice?: boolean;
}

const UnidentifiedMaterialsBanner = ({
  materials,
  className,
  isInvoice = true,
}: Props) => {
  const { t } = useTranslation();

  return materials?.length ? (
    <Banner
      variant="warning"
      className={className}
      id="unidentified-source-materials-banner"
      title={t("invoices.unidentifiedSource.title")}
    >
      <div>{t("invoices.unidentifiedSource.prefix")}</div>
      <ul>
        {materials.map((m) => (
          <li key={m.materialCode}>
            {t("invoices.unidentifiedSource.row", {
              weight: formatWeight(
                m.units.unitQuantity / (isInvoice ? 1 : 1000)
              ),
              material: m.materialName,
            })}
          </li>
        ))}
      </ul>
      {isInvoice && <div>{t("invoices.unidentifiedSource.suffix")}</div>}
    </Banner>
  ) : null;
};

export default UnidentifiedMaterialsBanner;
